window.checkoutWithProtection = async function () {

  // trigger native checkout so MinMaxify runs validation
  const nativeCheckoutBtn = document.querySelector('[name="checkout"]:not(#checkoutWithProtection)');

  if (nativeCheckoutBtn) {
    const form = nativeCheckoutBtn.closest("form");

    if (form) {
      const preventNav = (e) => e.preventDefault();

      // temporarily stop navigation
      form.addEventListener("submit", preventNav, { once: true });

      nativeCheckoutBtn.click();

      await new Promise(requestAnimationFrame);

      // if MinMaxify blocked → stop everything
      if (document.querySelector('dialog.minmaxify-dlg[open]')) {
        console.log("MinMaxify blocked checkout");
        return;
      }
    }
  }
  
  const checkoutButton = document.getElementById("checkoutWithProtection");
  if (!checkoutButton || checkoutButton.disabled) return;

  checkoutButton.disabled = true;
  checkoutButton.style.pointerEvents = "none";

  const buttonText = checkoutButton.querySelector(".button-text");
  const spinner = checkoutButton.querySelector(".spinner");
  if (buttonText) buttonText.style.display = "none";
  if (spinner) spinner.style.display = "inline-block";

  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    if (!cart.items || cart.items.length === 0) {
      window.location.href = "/checkout";
      return;
    }

    const alreadyInCart = cart.items.some(item =>
      item.handle && item.handle.includes("shipping-protection")
    );
    if (alreadyInCart) {
      window.location.href = "/checkout";
      return;
    }

    let variantId = null;
    try {
      const apiRes = await fetch("/apps/toolbox-leachs/api/shippingprotection", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cartItems: cart.items }),
      });

      if (apiRes.ok) {
        const apiData = await apiRes.json();
        variantId = apiData.variantId;
      }
    } catch (_) {}

    if (!variantId) {
      window.location.href = "/checkout";
      return;
    }

    const newCartItems = [
      { id: variantId, quantity: 1 },
      ...cart.items.map(item => {
        const newItem = {
          id: item.variant_id,
          quantity: item.quantity,
        };

        if (item.properties && Object.keys(item.properties).length > 0) {
          newItem.properties = item.properties;
        }

        if (item.selling_plan_allocation?.selling_plan) {
          newItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
        }

        return newItem;
      }),
    ];

    await fetch("/cart/clear.js", { method: "POST" });

    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: newCartItems }),
    });

    const addedItems = await addRes.json();

    let addedProtection = null;

    if (Array.isArray(addedItems.items)) {
      addedProtection = addedItems.items.find(
        item => String(item.variant_id) === String(variantId)
      );
    } else if (Array.isArray(addedItems)) {
      addedProtection = addedItems.find(
        item => String(item.variant_id) === String(variantId)
      );
    } else if (String(addedItems?.variant_id) === String(variantId)) {
      addedProtection = addedItems;
    }

    if (addedProtection) {
      sessionStorage.setItem("shippingProtection", addedProtection.variant_id);
      sessionStorage.setItem("shippingProtectionKey", addedProtection.key);
      sessionStorage.setItem("protectionTriggered", "true");
    }

    window.location.href = "/checkout";
  } catch (_) {
    window.location.href = "/checkout";
  }
};

window.updateShippingProtectionUI = function () {
  if (!window.theme.shippingProtection) return;

  const totalElement = document.querySelector("[data-general-total]");
  const totalPriceEl = document.querySelector("#protectedCheckoutPriceTotal");
  const protectionPriceEl = document.querySelector("#protectedCheckoutPrice");

  if (!totalElement || !totalPriceEl || !protectionPriceEl) return;

  const rawSubtotal = totalElement.getAttribute("data-general-total");
  let subtotal = parseFloat(rawSubtotal) / 100;
  if (!subtotal || isNaN(subtotal)) return;
  
  const protectionPriceList = [
    0.75, 1.5, 2, 2.25, 3, 3.75, 4.5, 5.25, 6, 6.75, 7.5, 8.25, 9, 9.75, 10.5, 11.25, 12,
    12.75, 13.5, 14.25, 15, 15.75, 16.5, 17.25, 18, 18.75, 19.5, 20.25, 21, 21.75, 22.5,
    23.25, 24, 24.75, 25.5, 26.25, 27, 27.75, 28.5, 29.25, 30, 30.75, 31.5, 32.25, 33,
    33.75, 34.5, 35.25, 36, 36.75, 37.5, 38.25, 39, 39.75, 40.5, 41.25, 42, 42.75, 43.5,
    44.25, 45, 45.75, 46.5, 47.25, 48, 48.75, 49.5, 50.25, 51, 51.75, 52.5, 53.25, 54,
    54.75, 55.5, 56.25, 57, 57.75, 58.5, 59.25, 60, 60.75, 61.5, 62.25, 63, 63.75, 64.5,
    65.25, 66, 66.75, 67.5, 68.25, 69, 69.75, 70.5, 71.25, 72, 72.75, 73.5, 74.25, 75,
    75.75, 76.5, 77.25, 78, 78.75, 79.5, 80.25, 81, 81.75, 82.5, 83.25, 84, 84.75, 85.5,
    86.25, 87, 87.75, 88.5, 89.25, 90, 90.75, 91.5, 92.25, 93, 93.75, 94.5, 95.25, 96,
    96.75, 97.5, 98.25, 99, 99.75, 100.5, 101.25, 102, 102.75, 103.5, 104.25, 105, 105.75,
    106.5, 107.25, 108, 108.75, 109.5, 110.25, 111, 111.75, 112.5, 113.25, 114, 114.75,
    115.5, 116.25, 117, 117.75, 118.5, 119.25, 120, 120.75, 121.5, 122.25, 123, 123.75,
    124.5, 125.25, 126, 126.75, 127.5, 128.25, 129, 129.75, 130.5, 131.25, 132, 132.75,
    133.5, 134.25, 135, 135.75, 136.5, 137.25, 138, 138.75, 139.5, 140.25, 141, 141.75,
    142.5, 143.25, 144, 144.75, 145.5, 146.25, 147, 147.75, 148.5, 149, 149.9, 150.8,
    151.7, 152.6, 153.5, 154.4, 155.3, 156.2, 157.1, 158, 158.9, 159.8, 160.7, 161.6,
    162.5, 163.4, 164.3, 165.2, 166.1, 167, 167.9, 168.8, 169.7, 170.6, 171.5, 172.4,
    173.3, 174.2, 175.1, 176, 176.9, 177.8, 178.7, 179.6, 180.5, 181.4, 182.3, 183.2,
    184.1, 185, 185.9, 186.8, 187.7, 188.6, 189.5, 190.4, 191.3, 192.2, 193.1, 194,
    194.9, 195.8, 196.7, 197.6, 198.5, 199.4, 200.3, 201.2, 202.1, 203, 203.9, 204.8,
    205.7, 206.6, 207.5, 208.4, 209.3, 210.2, 211.1, 212, 212.9, 213.8, 214.7, 215.6,
    216.5, 217.4, 218.3, 219.2, 220.1, 221, 221.9, 222.8, 223.7, 224.6, 225.5, 226.4,
    227.3, 228.2, 229.1, 230, 230.9, 231.8, 232.7, 233.6, 234.5, 235.4, 236.3, 237.2,
    237.95, 238.7, 239.45, 240.2, 240.95, 241.7, 242.45, 243.2, 243.95, 244.7, 245.45,
    246.2, 246.95, 247.7, 248.45, 249.2, 249.95, 250.7, 251.45, 252.2, 252.95, 253.7,
    254.45, 255.2, 255.95, 256.7, 257.45, 258.2, 258.95, 259.7, 260.45, 261.2, 261.95,
    262.7, 263.45, 264.2, 264.95, 265.7, 266.45, 267.2, 267.95, 268.7, 269.45, 270.2,
    270.95, 271.7, 272.45, 273.2, 273.95, 274.7, 275.45, 276.2, 276.95, 277.7, 278.45,
    279.2, 279.95, 280.7, 281.45, 282.2, 282.95, 283.7, 284.45, 285.2, 285.95, 286.7,
    287.45, 288.2, 288.95, 289.7, 290.45, 291.2, 291.95, 292.7, 293.45, 294.2, 294.95,
    295.7, 296.45, 297.2, 297.95, 298.7, 299.45, 300.2, 300.95, 301.7, 302.45, 303.2,
    303.95, 304.7, 305.45, 306.2, 306.95, 307.7, 308.45, 309.2, 309.95, 310.7, 311.45,
    312.2, 314.15, 316.1, 318.05, 320, 321.95, 323.9, 325.85, 327.8, 329.75, 331.7,
    333.65, 335.6, 337.55, 339.5, 341.45, 343.4, 345.35, 347.3, 349.25, 351.2, 353.15,
    355.1, 357.05, 359, 360.95, 362.9, 364.85, 366.8, 368.75, 370.7, 372.65, 374.6,
    376.55, 378.5, 380.45, 382.4, 384.35, 386.3, 388.25, 390.2, 392.15, 394.1, 396.05,
    398, 399.95, 401.9, 403.85, 405.8, 407.75, 409.7, 411.65, 413.6, 415.55, 417.5,
    419.45, 421.4, 423.35, 425.3, 427.25, 429.2, 431.15, 433.1, 435.05, 437, 438.95,
    440.9, 442.85, 444.8, 446.75, 448.7, 450.65, 452.6, 454.55, 456.5, 458.45, 460.4,
    462.35, 464.3, 466.25, 468.2, 470.15, 472.1, 474.05, 476, 477.95, 479.9, 481.85,
    483.8, 485.75, 487.7, 489.65, 491.6, 493.55, 495.5, 497.45, 500, 501.35, 503.3
  ];

 const percentageValue = subtotal * 0.027;
  const closestPrice =
    protectionPriceList.find(price => price >= percentageValue) ||
    protectionPriceList[protectionPriceList.length - 1];

  const totalWithProtection = (subtotal + closestPrice).toFixed(2);

  totalPriceEl.textContent = totalWithProtection;
  protectionPriceEl.textContent = closestPrice.toFixed(2);
};

document.addEventListener("DOMContentLoaded", function () {
  const miniCartTop = document.querySelector('.mini-cart');
  if (miniCartTop) {
    miniCartTop.addEventListener('cart:rerendered', function () {
      if (typeof window.updateShippingProtectionUI === 'function') {
        window.updateShippingProtectionUI();
      }
    });
  }
});


document.addEventListener("cart:rerendered", function () {
  if (typeof window.updateShippingProtectionUI === "function") {
    window.updateShippingProtectionUI();
  }
});

document.addEventListener("DOMContentLoaded", async function () {
  const triggered = sessionStorage.getItem("protectionTriggered");
  if (triggered !== "true") return;

  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    const protectionItem = cart.items.find(item =>
      item.handle && item.handle.includes("shipping-protection")
    );

    if (protectionItem) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: protectionItem.key,
          quantity: 0
        })
      });

      // Trigger cart refresh events
      document.dispatchEvent(new CustomEvent("cart:rerendered"));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

      // Wait a bit before updating cart count
      setTimeout(async () => {
        const updatedCartRes = await fetch("/cart.js");
        const updatedCart = await updatedCartRes.json();
        const updatedCount = updatedCart.items.reduce((sum, item) => sum + item.quantity, 0);

        const countEl = document.querySelector(".header__cart-count");
        if (countEl) countEl.textContent = updatedCount;

        if (window.theme && typeof window.theme.cartCount === "number") {
          window.theme.cartCount = updatedCount;
        }
      }, 500);
    }
  } catch (_) {}

  sessionStorage.removeItem("protectionTriggered");
});
